import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { ImageAndProductType } from "@swo/storefront";

import { css } from "@emotion/react";

import { CSS_COLORS } from "../../styles/styles-css-variables";
import { Options } from "@contentful/rich-text-react-renderer";
import React from "react";
import { BLOCKS } from "@contentful/rich-text-types";
import { CSS_MQ } from "../../styles/breakpoints";
import { ImageAuthorLabel } from "./ImageAuthorLabel";
import { fontColor, FONTS } from "../../styles/fonts";
import { richTextStyles } from "../../styles/rich-text";
import { hyperlinksOptions, transformJson } from "../../utils/contentful/rich-text-formatting";
import { plainTextStyles } from "../../styles/text-styles";
import { EXPERIMENTAL_TextWithProductNameRenderer } from "../../domain/swarovski-optik/products/product-name/product-name-renderer";
import { SORichTextRenderer } from "../_shared-components/so-rich-text";

const options: Options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => (
      <p
        css={[
          css`
            margin-top: 0;
          `,
          FONTS.SwarovskiFutura300,
          fontColor.black,
          plainTextStyles,
        ]}
      >
        {children}
      </p>
    ),
  },
};

export const ImageAndProductDescription: ReactTFC<
  Pick<ImageAndProductType, "richText" | "headline"> & {
    imageAuthor?: string;
    photographyAuthorLabelTranslation: React.ReactNode;
  }
> = props => {
  return props.headline || props.richText || props.imageAuthor ? (
    <div
      css={css`
        padding-top: var(--m);

        ${richTextStyles};
      `}
    >
      {props.headline && (
        <span css={headlineStyles}>
          <EXPERIMENTAL_TextWithProductNameRenderer text={props.headline} />
        </span>
      )}

      {props.richText && (
        <SORichTextRenderer
          richText={props.richText}
          options={{
            renderNode: { ...hyperlinksOptions.renderNode, ...options.renderNode },
          }}
        />
      )}

      {props.imageAuthor && (
        <ImageAuthorLabel
          photographyAuthorLabelTranslation={props.photographyAuthorLabelTranslation}
          label={props.imageAuthor}
        />
      )}
    </div>
  ) : (
    <span />
  );
};

const headlineStyles = css`
  font-family: MinervaModern;
  color: ${CSS_COLORS.Green};

  font-size: 24px;
  letter-spacing: 0.4px;
  line-height: 26px;
  margin-bottom: 8px;

  ${CSS_MQ.atLeastLg} {
    font-size: 40px;
    letter-spacing: 2px;
    line-height: 42px;
    margin-bottom: 20px;
  }

  text-transform: uppercase;
  display: block;
`;
